module.exports = __webpack_public_path__ + "img/eoceans1.827d97f8.jpg";